import React from 'react';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';

const ButtonLeftIcon = ({ label, icon, ...other }) => (
	<Button {...other}>
		<Icon sx={theme => ({ marginRight: theme.spacing.unit })}>{icon}</Icon>
		{label}
	</Button>
);

export default ButtonLeftIcon;
